import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadAllPromosAction } from '../../actions/promos';
import { ShowAllButton } from '../../components/ShowAllButton';
import { selectIsLoading } from '../../selectors/loading';
import { TThunkDispatch } from '../../types/redux/thunk';

export const ShowAllButtonContainer: React.FC = () => {
  const isLoading = useSelector(selectIsLoading);
  const dispatch: TThunkDispatch = useDispatch();

  const loadPromos = React.useCallback(() => {
    dispatch(loadAllPromosAction());
  }, [dispatch]);

  return <ShowAllButton onClick={loadPromos} disabled={isLoading} />;
};
